module.exports = __webpack_public_path__ + "media/images/category/feature/coj_d/hero_mob-530bccb16fd9b14050660dfc1770bcab.jpg";